import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import classNames from 'classnames';
import * as selectors from 'selectors/pathBuilder';
import ContentWrapper from '../Content/Wrapper';
import Header from './Header';
import Step from './Step';
import { withStatusModifier } from '../helpers.js';
import HiddenStepsPlaceholder from '../HiddenStepsPlaceholder';
import ContentDescription from '../../PathBuilder/ContentList/ContentDescription';
import PathContentSteps from '../../PathBuilder/ContentList/PathContentSteps';

const ConditionalRender = ({ on, children }) => {
  if (!on) return false;
  return children.length > 1 ? <div>{children}</div> : children;
};

const getPathContentClassNames = props => {
  const completed = props.status === 'completed';

  return classNames({
    PathContent: completed,
    'PathContent--subContent': true,
    [withStatusModifier('PathContent', props.status)]: !completed,
  });
};

const PathContent = props => (
  <ContentWrapper>
    <div className={getPathContentClassNames(props)}>
      <Header {...props} />
      <div className="PathContent-body">
        <ConditionalRender on={props.description}>
          <ContentDescription description={props.description} />
        </ConditionalRender>
        <ConditionalRender on={!isEmpty(props.contents)}>
          <PathContentSteps contents={props.contents}>
            {step => <Step key={step.id} {...step} />}
          </PathContentSteps>
        </ConditionalRender>
        <ConditionalRender on={!props.asHeader && props.hiddenContents}>
          <HiddenStepsPlaceholder pathTitle={props.title} />
        </ConditionalRender>
      </div>
    </div>
  </ContentWrapper>
);

const mapStateToProps = () => {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathViewer, props),
  });
};

export default connect(mapStateToProps)(PathContent);
